// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Fonts/Synonym-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Synonym;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

.test1 > div {
  /* Ajoutez vos styles ici */
  width: calc(100% - 0px) !important; /* Ajustement pour ignorer la barre de défilement */
  overflow-x: hidden; /* Évite le défilement horizontal */
}


body{
  background: #0c0b20;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #c3d32c;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background: #c3d32c;
}
::-webkit-scrollbar-thumb:active {
  background: #c3d32c;
}
::-webkit-scrollbar-track {
  background: #0c0b20;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-track:hover {
  background: #0c0b20;
}
::-webkit-scrollbar-track:active {
  background: #0c0b20;
}
::-webkit-scrollbar-corner {
  background: transparent;
}

.loadingScreen{
  width: 100%;
  height: 100vh;
  background: #0c0b20;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,4CAA8C;AAChD;AACA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC,EAAE,mDAAmD;EACvF,kBAAkB,EAAE,mCAAmC;AACzD;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n@font-face {\n  font-family: Synonym;\n  src: url('./assets/Fonts/Synonym-Regular.ttf');\n}\n*{\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.test1 > div {\n  /* Ajoutez vos styles ici */\n  width: calc(100% - 0px) !important; /* Ajustement pour ignorer la barre de défilement */\n  overflow-x: hidden; /* Évite le défilement horizontal */\n}\n\n\nbody{\n  background: #0c0b20;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n::-webkit-scrollbar-button {\n  width: 0px;\n  height: 0px;\n}\n::-webkit-scrollbar-thumb {\n  background: #c3d32c;\n  border: 0px none #ffffff;\n  border-radius: 50px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #c3d32c;\n}\n::-webkit-scrollbar-thumb:active {\n  background: #c3d32c;\n}\n::-webkit-scrollbar-track {\n  background: #0c0b20;\n  border: 0px none #ffffff;\n  border-radius: 50px;\n}\n::-webkit-scrollbar-track:hover {\n  background: #0c0b20;\n}\n::-webkit-scrollbar-track:active {\n  background: #0c0b20;\n}\n::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n.loadingScreen{\n  width: 100%;\n  height: 100vh;\n  background: #0c0b20;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
